import { render, staticRenderFns } from "./ModalAddEditVm.vue?vue&type=template&id=3660d8c8&scoped=true&lang=html&"
import script from "./ModalAddEditVm.vue?vue&type=script&lang=js&"
export * from "./ModalAddEditVm.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddEditVm.vue?vue&type=style&index=0&id=3660d8c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3660d8c8",
  null
  
)

export default component.exports